exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-parametrage .wrap[data-v-594da204]{height:100%}.tab-parametrage.active .wrap[data-v-594da204]{height:calc(100% - 35px);overflow-y:auto}.tab-parametrage.active .area-action[data-v-594da204]{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-594da204","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/ficheSociete/parametrage/parametrageSociete.scss
// module id = 2Ii6
// module chunks = 2